import Obeyman from 'obeyman';

export default {
    info: {
        method: 'GET',
        url: '/user/:uid/recent/{time}',
        name: '获取用户信息',
    },
    getTencent: {
        method: 'GET',
        url: '/manage-system/internal/tencent/{userId}',
        name: '根据userId获取腾讯内购活动参与详情',
    },
    saveTencent: {
        method: 'POST',
        url: '/manage-system/internal/tencent',
        name: '修改腾讯内购活动参与记录',
    },
    getTeacher2021: {
        method: 'GET',
        url: '/manage-system/teacher2021/{userId}',
        name: '根据userId获取2021教师节活动参与详情',
    },
    saveTeacher2021: {
        method: 'PUT',
        url: '/manage-system/teacher2021/userInfo',
        name: '修改2021教师节活动身份信息',
    },
    login: {
        method: 'POST',
        url: '/manage-system/staff/ms/login',
        name: '登录'
        // schema: Obeyman.object().keys({
        //     body: Obeyman.object().keys({
        //         account: Obeyman.string().required(),
        //         password: Obeyman.string().required(),
        //         // ts: Obeyman.number().optional()
        //     }),
        //     // query: Obeyman.object().keys({

        //     // })
        // })
    },
}
